module.exports = __webpack_public_path__ + "img/apple.feb8fbd3.png";